import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DonarListComponent} from './donar-list.component';

const routes: Routes = [
    {
        path: '', component: DonarListComponent
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/donar-list/donar-list.routing.ts